import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { ContributionRequestStatus } from '../../Contributions/contributions.types';

const useChangeContributionStatusQuery = (contributionId?: string, onSuccess?: () => void) => {
  const { mutateAsync, isLoading, isSuccess } = useMutation(
    async (status: ContributionRequestStatus) =>
      api.patch(
        API_URL.CONTRIBUTIONS_CONTRIBUTION_REQUESTS_STATUS_BY_REQUEST_ID(contributionId || ''),
        undefined,
        {
          params: {
            status: status,
          },
        }
      ),
    {
      onSuccess: () => {
        if (onSuccess) onSuccess();
      },
    }
  );

  return {
    changeContributionStatus: mutateAsync,
    isLoading,
    isSuccess,
  };
};

export default useChangeContributionStatusQuery;
